<template>
    <CompassTooltip
        :content="$t.__(getExtensionOption(option).label)"
        placement="top"
        :delay="{ show: 0, hide: 1 }"
        :disabled="disabled"
    >
        <CompassIconButton
            :icon="getExtensionOption(option).icon"
            size="small"
            :disabled="disabled"
            :active="activeStyle(option)"
            @click="selectFile"
        />
        <input
            ref="fileInput"
            type="file"
            :accept="allowedImage"
            style="display: none"
            @change="handleFileChange"
        />
    </CompassTooltip>
</template>

<script>
import OptionsRichTextMixin from 'mixins/OptionsRichTextMixin';

export default {
    name: 'ImageRichText',
    mixins: [OptionsRichTextMixin],
    data() {
        return {
            allowedImage: '.apng, .gif, .ico, .jpg, .jpeg, .jfif, .pjpeg, .pjp, .png, .svg',
        };
    },
    methods: {
        // Select a file from the computer
        selectFile() {
            this.$refs.fileInput.click();
        },
        // Handle the file change (when a file is selected)
        handleFileChange(event) {
            const selectedFile = event.target.files[0];
            if (selectedFile) {
                this.editor.commands.setImage({
                    src: URL.createObjectURL(selectedFile),
                    alt: selectedFile.name,
                    title: selectedFile.name,
                });
            }
        },
    },
};
</script>
